import React from 'react';
import ContentLayout from '../../../../components/ContentLayout';
import Tabs from '../../../../components/Tabs';
import props from '../../../../lib/contentLayoutProps/learning-at-kingston/primary-school/layoutProps';

import styles from './index.module.scss';

import eliza from './eliza@small.jpg';
import emily from './emily@small.jpg';
import fenwick from './fenwick@small.jpg';
import john from './john@small.jpg';

const tabs = ['Eliza Wong', 'John Harper', 'Emily Flach', 'Fenwick Tong'];

/* eslint-disable react/prop-types */
export default class extends React.Component {
  state = {
    tab: 0,
  };

  render() {
    const { tab } = this.state;

    return (
      <ContentLayout {...props} locale="en" pageKey="leadership-team">
        <h1>Leadership Team</h1>
        <Tabs tabs={tabs} onChangeTab={index => this.setState({ tab: index })} />
        {tab === 0 && (
          <React.Fragment>
            <h3>Ms. Eliza Wong</h3>
            <p>Head Principal</p>
            <div className={styles.container}>
              <div className={styles.image}>
                <img src={eliza} alt="Eliza Wong" />
              </div>
              <div>
                <p>
                  Ms. Eliza Wong has been working in education for the last 33 years and in 1997 she joined the family
                  of Kingston International School as a Head Teacher. She was promoted to Kindergarten Principal in
                  2001, and by 2008, she took on the additional role of Primary School Principal at Kingston
                  International School. In the latter half of that year, the School Board decided to promote Ms. Wong to
                  the Head Principal position over both the Kindergarten and Primary Schools of Kingston. From 2009
                  onwards, she became a Board member of the International College of Hong Kong, the through-train high
                  school division of Kingston International School.
                </p>
                <p>
                  Ms. Wong was heavily involved in the expansion of Kingston, as the demand for admission spots far
                  exceeded its supply. Seeing the pressing need for expansion, she dedicated tremendous effort towards
                  it and was rewarded when Kingston opened up its Lower Primary division in 2001 and its Upper Primary
                  division in 2010 to allow more students to join the Kingston family. In regards to learning, Ms. Wong
                  demonstrated great initiative in paving the way for the school’s further academic development by
                  receiving training on the IBPYP curriculum, prior to establishing Kingston’s Primary School. In order
                  to prepare herself for this step, she participated in numerous IB workshops and visited IB schools in
                  various places such as Switzerland, Australia, Thailand, Shanghai, Beijing, Vietnam, India, and
                  Singapore for academic exchange with the management levels. As for the linguistic aspect, she
                  emphasized the need for a strong and solid Chinese curriculum on par with their English counterpart
                  program to maintain a bilingual curriculum of the highest caliber across the international school
                  stage in Hong Kong.
                </p>
              </div>
            </div>
          </React.Fragment>
        )}

        {tab === 1 && (
          <React.Fragment>
            <h3>John Harper</h3>
            <p>Upper Primary Principal</p>
            <div className={styles.container}>
              <div className={styles.image}>
                <img src={john} alt="John Harper" />
              </div>
              <div>
                <p>
                  John Harper was born and raised in Canada. He arrived in Hong Kong in 1998 and has been at Kingston
                  since 2002. Starting out as a K3 teacher in our Kindergarten section, John's interest in the IBPYP led
                  him to become an IBPYP Workshop Leader and School Evaluator. These extra qualifications made it a
                  logical move for him to become the KIK PYP Coordinator and, eventually, KIK Head English Teacher. In
                  2007, John moved into the Deputy Principal / PYP Coordinator position in the Primary Section. In 2014,
                  he was appointed Kingston's Upper Primary Principal.
                </p>
                <p>
                  John is very happy to have been part of the Kingston experience for such an extended period of time.
                  He was teaching at Kingston in the first year that we expanded to include a primary section. He was
                  part of the original IBPYP Authorization process and has participated in every KIS IB Evaluation
                  since. During his tenure at Kingston, he has had the privilege of collaboratively developing the
                  primary school curriculum and learning approaches with a talented and diverse team and has valued the
                  experiences involved in participating in the growth of the most distinguished small school in Hong
                  Kong. Currently, as Upper Primary Principal, John is responsible for student-wellbeing, recruiting
                  high-quality teachers, overseeing curriculum, planning essential professional development,
                  contributing to school development and much more.
                </p>
                <p>
                  John has a Bachelor of Arts (English) from Carleton University in Ottawa, a Post-Graduate Certificate
                  in Education from the University of Sunderland (UK), a Master of Education Management from the
                  University of Bristol (UK) and is currently at the dissertation stage of his Doctor of Education from
                  the University of Bristol. John also lectures part-time for the PGDE programme at the University of
                  Hong Kong.
                </p>
                <p>
                  John is a proud father and he and his wife have chosen to send their young son to Kingston. They are
                  most drawn to Kingston for the bilingual approach, the reassurance and personal attention that comes
                  from the small school experience, the overall quality of the teaching and learning, and the deep
                  organizational knowledge that comes with being the first school in Hong Kong to be authorized to
                  deliver the International Baccalaureate Primary Years Programme.
                </p>
              </div>
            </div>
          </React.Fragment>
        )}

        {tab === 2 && (
          <React.Fragment>
            <h3>Ms. Emily Flach</h3>
            <p>Lower Primary Principal and Whole School PYP Coordinator</p>
            <div className={styles.container}>
              <div className={styles.image}>
                <img src={emily} alt="Emily Flach" />
              </div>
              <div>
                <p>
                  Emily Flach has over 20 years experience as an educator. Originally from Canada, she began her career
                  as an Early Childhood Special Education Teacher in Vancouver. Emily joined the Kingston team in 2004.
                  She began her Kingston career as a K3 classroom teacher and eventually became the English Head teacher
                  at our Kindergarten. In 2007 Emily chose to join the Kingston Primary team as a Y1 class teacher. Her
                  education, experience and skills led to her appointment as Assistant PYP Coordinator and Deputy
                  Principal in 2010 and she was subsequently named Principal of Lower Primary in 2014. She has just
                  recently taken on the role of PYP Coordinator across the lower and upper primary schools.
                </p>
                <p>
                  Emily also has two children who have attended Kingston since playgroup and are now in the Primary
                  School. This variety of roles has allowed her to gain a thorough understanding of all aspects of the
                  school. With this knowledge she has worked with all members of the Kingston community to continually
                  improve the school. She is always in awe of the the students and teachers of Kingston who strive for
                  excellence in English and Putonghua. Emily has numerous roles at the school including curriculum
                  development, staff development, student well-being, teacher recruitment, and student enrolment.
                </p>
                <p>
                  Emily has a Bachelor of Arts in Psychology from Carleton University in Ottawa, an Early Childhood
                  Certificate from Capilano College in Vancouver, a Certificate in Early Childhood Education - Special
                  Education from Langara College in Vancouver, a Postgraduate Diploma of Education - Special Education
                  from the University of Hong Kong, a Master of Education in Educational Studies from the University of
                  Hong Kong and a Masters of Educational Management from the University of Bristol. Emily is always
                  striving to extend her knowledge through higher education, workshops, readings and conversations with
                  other professionals. She has been trained by the IB-PYP to be a workshop leader and school evaluator.
                </p>
                <p>
                  Emily is passionate about education and fascinated with the amazing capacity and enthusiasm students
                  have for learning. She is proud to be a part of the Kingston team and strives to maintain the
                  welcoming atmosphere where students and parents feel a part of the community.
                </p>
              </div>
            </div>
          </React.Fragment>
        )}

        {tab === 3 && (
          <React.Fragment>
            <h3>Ms. Fenwick Tong</h3>
            <p>Vice Principal & Head of Chinese</p>
            <div className={styles.container}>
              <div className={styles.image}>
                <img src={fenwick} alt="Fenwick Tong" />
              </div>
              <div>
                <p>
                  Ms. Tong was born in mainland China and has been passionate about learning Chinese Language from a
                  young age. She was educated in Putonghua and graduated from high school in China. With the dream of
                  devoting herself to education, Ms. Tong graduated from the Education University of Hong Kong in 2004
                  with a Bachelor Degree of Education (Honours) (Primary) and was subsequently registered as a teacher
                  with the EDB. Her first posting was as a class teacher here at KIS, the first authorized IBPYP school
                  in Hong Kong.
                </p>
                <p>
                  In 2008, Ms. Tong completed her Master of Education (Curriculum and Teaching Methodology) from Beijing
                  Language And Culture University. In the same year, she was appointed Kingston's Head Chinese Teacher,
                  marking the beginning of a successful collaboration with the rest of the Chinese team to design a
                  IBPYP-based Chinese curriculum for the school. Ms. Tong has also led the team in developing Kingston's
                  Chinese Language Inquiry Book Sets, the Lower Primary Chinese Idiom Book and the Upper Primary Chinese
                  Idiom Book, each of which is aimed at supplementing the highest quality Chinese language education for
                  KIS students.
                </p>
                <p>
                  In August 2016, Ms. Tong was appointed Vice Principal, and became more widely and deeply involved in
                  Kingston’s educational administration work - assisting the principals in hiring quality Chinese
                  teachers, continuously developing Chinese curriculum and promoting the school’s development and
                  professional development of the Chinese teachers.
                </p>
                <p>
                  In 2017, Ms. Tong completed the Preparation For Principalship programme at Hong Kong Baptist
                  University and acquired her Certification for Principalship.
                </p>
              </div>
            </div>
          </React.Fragment>
        )}
      </ContentLayout>
    );
  }
}
